import { AccountData } from '../../../../../api';
import { PriceMode } from '../../../../../common/OrderUtils';
import { useAuth } from '../../../../../session/InternalAuthProvider';
// @ts-ignore
import { useEditOrder } from '../../EditOrderContext';
import { depositAmountOf, PaymentModel, paymentModelOf } from './paymentModel';

type UsePaymentModelResult = {
  model: PaymentModel;
  // Undefined when the experience has no deposit.
  deposit: number | undefined;
};

export const usePaymentModel = (isVoucherRedeem: boolean): UsePaymentModelResult => {
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  // @ts-ignore
  const { editOrderState, isDropInPricingFlow } = useEditOrder();

  // In the drop-in flow, turning a payment link on switches the price mode to CALCULATED; the order is still a
  // pay-at-the-visit one, so the flow itself decides, not the current price mode.
  const model = paymentModelOf({
    orderPage: editOrderState.orderPage,
    account,
    priceMode: isDropInPricingFlow ? PriceMode.ZERO : editOrderState.priceMode,
    isVoucherRedeem,
  });
  const deposit = depositAmountOf(
    editOrderState.orderPage,
    account,
    editOrderState.details.persons,
    editOrderState.calculatedPrice,
  );
  return { model, deposit };
};
